export const API_URL = `https://equbszd8yb.execute-api.ap-southeast-2.amazonaws.com/v1/staging`;
export const API_V2_URL = `https://prod-api-v2.campaignware.com`;
export let delayTime = "7000";
export const RANDOMIZER_REDUCE_INVENTORY_ON_SHOW_LIST = [4070, 6151];
export const REESES_CAMPAIGN = [8433];
